module.exports = __webpack_public_path__ + "img/welcome_screen-w.svg";